var IconName = {
  ArrowLeftLg: "ArrowLeftLg",
  ArrowLeftSm: "ArrowLeftSm",
  ArrowLeftXl: "ArrowLeftXl",
  ArrowRightLg: "ArrowRightLg",
  ArrowRightSm: "ArrowRightSm",
  ArrowRightXl: "ArrowRightXl",
  CaretBottom: "CaretBottom",
  CaretLeft: "CaretLeft",
  CaretRight: "CaretRight",
  CaretTop: "CaretTop",
  CheckCircle: "CheckCircle",
  Check: "Check",
  ChevronBottom: "ChevronBottom",
  ChevronLeft: "ChevronLeft",
  ChevronRight: "ChevronRight",
  ChevronTop: "ChevronTop",
  Close: "Close",
  Delete: "Delete",
  Edit: "Edit",
  InfoFill: "InfoFill",
  Info: "Info",
  Refresh: "Refresh",
  Trash: "Trash"
};
module.exports = {
  IconName: IconName,
  icons: {
    ArrowLeftLg: require('./icons/arrow-left-lg'),
    ArrowLeftSm: require('./icons/arrow-left-sm'),
    ArrowLeftXl: require('./icons/arrow-left-xl'),
    ArrowRightLg: require('./icons/arrow-right-lg'),
    ArrowRightSm: require('./icons/arrow-right-sm'),
    ArrowRightXl: require('./icons/arrow-right-xl'),
    CaretBottom: require('./icons/caret-bottom'),
    CaretLeft: require('./icons/caret-left'),
    CaretRight: require('./icons/caret-right'),
    CaretTop: require('./icons/caret-top'),
    CheckCircle: require('./icons/check-circle'),
    Check: require('./icons/check'),
    ChevronBottom: require('./icons/chevron-bottom'),
    ChevronLeft: require('./icons/chevron-left'),
    ChevronRight: require('./icons/chevron-right'),
    ChevronTop: require('./icons/chevron-top'),
    Close: require('./icons/close'),
    Delete: require('./icons/delete'),
    Edit: require('./icons/edit'),
    InfoFill: require('./icons/info-fill'),
    Info: require('./icons/info'),
    Refresh: require('./icons/refresh'),
    Trash: require('./icons/trash')
  }
};